import { z } from 'zod';

export const termsVersion = '2026-11-02';
export const registrationInput = z.object({
    name: z.string().trim().min(1).max(200),
    email: z.string().trim().toLowerCase().pipe(z.email().max(254)),
    password: z.string().min(12).max(128),
    organization: z.string().trim().min(1).max(200),
    termsAccepted: z.literal(true),
    termsVersion: z.literal(termsVersion),
    proof: z.string().min(1).max(2048),
});
export const confirmationInput = z
    .object({
        email: z.string().trim().toLowerCase().pipe(z.email().max(254)),
        termsAccepted: z.literal(true).optional(),
        termsVersion: z.literal(termsVersion).optional(),
    })
    .refine((input) => Boolean(input.termsAccepted) === Boolean(input.termsVersion));
export const onboardingInput = z.object({
    productId: z.string().min(1).max(100),
    verticalId: z.string().min(1).max(100),
});
export const accountState = z.object({
    administrator: z.boolean(),
    twoFactorEnabled: z.boolean(),
    twoFactorRequired: z.boolean(),
    twoFactorVerified: z.boolean(),
    onboardingRequired: z.boolean(),
    selection: onboardingInput.nullable(),
});
export type AccountState = z.infer<typeof accountState>;

export const factorReplacementInput = z
    .object({
        password: z.string().min(1).max(128),
        method: z.enum(['totp', 'backup', 'session']),
        code: z.string().trim().max(128).default(''),
    })
    .refine((input) => input.method === 'session' || input.code.length > 0);
export const factorReplacementSetup = z.object({
    replacementId: z.uuid(),
    totpURI: z.string().startsWith('otpauth://totp/'),
    backupCodes: z.array(z.string()).length(10),
    expiresAt: z.iso.datetime(),
});
export const factorReplacementConfirmation = z.object({
    replacementId: z.uuid(),
    code: z.string().regex(/^\d{6}$/),
    codesSaved: z.literal(true),
});
